module.exports = __webpack_public_path__ + "static/3-28a2adfa8a87b3dcd67b2e2a46724074.jpg";